"use memo"

import { AutopilotTaskDto } from '@urbanx/agx.activities.client'
import {
  useGetCampaign,
  useStaffGetDocumentsForCampaign,
} from '@urbanx/agx.campaigns.client'
import type { TaskModalContentConfig } from 'pages/allTasks/TaskModal/TaskModalDialog'
import { TaskModalPageProps } from 'pages/allTasks/TaskModal/TaskModalPageProps'
import ExchangeTaskPage from './ExchangeTaskPage'
import { useExchangeTaskForm } from './useExchangeTaskForm'

interface UseExchangeTaskModalProps {
  campaignId: string
  isOpen: boolean
  tasks: AutopilotTaskDto[]
}

export const useExchangeTaskModal = ({
  campaignId,
  isOpen,
  tasks,
}: UseExchangeTaskModalProps) => {
  const contractId = tasks[0]?.contractId
  const firstIncompleteTaskIndex = tasks.findIndex(
    (task) => task.isCompleted !== true
  )
  const initialPageIndex =
    firstIncompleteTaskIndex >= 0 ? firstIncompleteTaskIndex : 0
  const { data: campaign, isPending: isCampaignPending } = useGetCampaign(
    campaignId,
    !!campaignId
  )

  const { data: documentGroups, isPending: documentsPending } =
    useStaffGetDocumentsForCampaign(campaignId, !!campaignId && isOpen)

  const exchangeForm = useExchangeTaskForm(campaignId, contractId, isOpen)

  const renderPage = (props: TaskModalPageProps) => (
    <ExchangeTaskPage {...props} exchangeForm={exchangeForm} />
  )

  const contentConfig: TaskModalContentConfig = {
    documents: documentGroups ?? [],
    isPending: isCampaignPending || documentsPending || exchangeForm.isPending,
    initialPageIndex,
    onSaveCurrentPage: (task) => exchangeForm.saveTask(task.category?.taskType),
    onSaveAllPages: (modalTasks) =>
      exchangeForm.saveTasks(
        modalTasks.map((task) => task.category?.taskType)
      ),
    renderPage,
  }

  return {
    campaign,
    contentConfig,
  }
}
